function t(t,{style:e,vars:s},o,n){Object.assign(t.style,e,n&&n.getProjectionStyles(o));for(const e in s)t.style.setProperty(e,s[e])}export{t as renderHTML};
